import { 
    REGISTRO_EXITOSO,
    REGISTRO_ERROR,
    OBTENER_USUARIO,
    PERFIL_OK,
    LOGIN_EXITOSO,
    LOGIN_ERROR,
    RECUPERO_CLAVE,
    ACTUALIZAR_CLAVE,
    RECUPERO_OK,
    REESTABLECER_CLAVE,
    CERRAR_SESION,
    EDITAR_PERFIL
} from 'types/context';

export default (state, action) => {
    let clienteRol;
    switch (action.type) {
        case REGISTRO_EXITOSO:
        case LOGIN_EXITOSO:
            localStorage.setItem('token', action.payload.token);
            /* clienteRol = action.payload.usuario.cliente.find(cli => cli.default === true); */
            return {
                ...state,
                autenticado: false,
                usuario: action.payload.usuario.usuario,
                cliente: action.payload.usuario.cliente.id,
                rol: action.payload.usuario.rol.nombre,
                mensaje: null,
                cargando: false
            }
        case RECUPERO_CLAVE:
            return {
                ...state,
                autenticado: false,
                mensaje: action.payload,
                cargando: false
            }
        case REESTABLECER_CLAVE:
            return {
                ...state,
                autenticado: false,
                mensaje: null,
                cargando: false
            }
        case ACTUALIZAR_CLAVE:
            return {
                ...state,
                autenticado: false,
                mensaje: null,
                cargando: false
            }
        case EDITAR_PERFIL:
        case OBTENER_USUARIO:
            //
            /* clienteRol = action.payload.clienteRol.find(cli => cli.default === true); */
            const telefono = action.payload.telefonos?.length>0 ? action.payload.telefonos[0] : {
                codigoArea:"",
                codigoPais:"",
                numeroTelefono:""
            };
            return {
                ...state,
                usuario: {
                    ...action.payload,
                    telefono
                },
                cliente: action.payload.cliente?.id,
                rol: action.payload.rol?.nombre,
                autenticado: true,
                cargando: false
            }
        case CERRAR_SESION:
        case LOGIN_ERROR:
        case RECUPERO_OK:
        case PERFIL_OK:
            return {
                ...state,
                mensaje: action.payload
            }
        case REGISTRO_ERROR:
            return {
                ...state,
                token: null,
                usuario: null,
                cliente: null,
                rol: null,
                autenticado: null,
                mensaje: action.payload,
                cargando: false
            }
        default:
            return state;
    }
}